import { useEffect, useRef, useState } from 'react';

/**
 * Returns true until the first fetch cycle (fetching: true → false) completes
 */
function useInitialLoading(fetching: boolean, isSSRFetched: boolean): boolean {
  const [loading, setLoading] = useState(!isSSRFetched);
  const hasFetchedOnce = useRef(false);

  useEffect(() => {
    if (fetching) hasFetchedOnce.current = true;
    if (!fetching && hasFetchedOnce.current) setLoading(false);
  }, [fetching]);

  return loading;
}

export default useInitialLoading;
